import { QuickAccessGroupMeta, QuickAccessPage } from '../../interfaces/ui/quick-access.interface';
import { Menu } from '../../interfaces/ui/nav.interface';
import { PERMITTED_VIEWS } from '../global/global.constant';
import { MENU_ITEMS } from './nav.constant';
import {
  QUICK_ACCESS_ACTIONS,
  QUICK_ACCESS_MENU_TYPE_LINK,
  QUICK_ACCESS_MENU_TYPE_SUB,
} from './quick-access.constant';

function collectLeaves(
  items: Menu[],
  topGroup: QuickAccessGroupMeta,
  currentGroup: QuickAccessGroupMeta,
  result: QuickAccessPage[]
): void {
  for (const item of items) {
    const nextGroup: QuickAccessGroupMeta =
      item.type === QUICK_ACCESS_MENU_TYPE_SUB && item.title
        ? { groupId: item.id, groupTitleKey: item.title, groupIcon: currentGroup.groupIcon }
        : currentGroup;

    if (
      item.path &&
      (item.type === QUICK_ACCESS_MENU_TYPE_LINK || item.type === QUICK_ACCESS_MENU_TYPE_SUB)
    ) {
      result.push({
        id: item.id,
        path: item.path,
        titleKey: item.title || '',
        groupId: nextGroup.groupId,
        groupTitleKey: nextGroup.groupTitleKey,
        groupIcon: nextGroup.groupIcon,
        topGroupId: topGroup.groupId,
        topGroupTitleKey: topGroup.groupTitleKey,
      });
    }

    if (item.children?.length) {
      collectLeaves(item.children, topGroup, nextGroup, result);
    }
  }
}

function buildCatalog(): QuickAccessPage[] {
  const result: QuickAccessPage[] = [];

  for (const group of MENU_ITEMS) {
    const groupMeta: QuickAccessGroupMeta = {
      groupId: group.id,
      groupTitleKey: group.title || '',
      groupIcon: group.icon || '',
    };

    collectLeaves([group], groupMeta, groupMeta, result);
  }

  for (const action of QUICK_ACCESS_ACTIONS) {
    result.push({
      id: action.id,
      path: '',
      titleKey: action.titleKey,
      groupId: action.id,
      groupTitleKey: action.titleKey,
      groupIcon: action.icon,
      topGroupId: action.id,
      topGroupTitleKey: action.titleKey,
      isAction: true,
    });
  }

  return result;
}

export const QUICK_ACCESS_CATALOG: QuickAccessPage[] = buildCatalog();
